const appConfig = {
    // apiPrefix: 'http://localhost:5100/api/',
    // apFilePrefix: 'http://localhost:5100',
     apiPrefix: 'https://fairwayfore.com/api/api',
     apFilePrefix: 'https://fairwayfore.com/api',
    authenticatedEntryPath: '/',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    enableMock: false
}

export default appConfig;




